if (!customElements.get('shipping-protection-toggle')) {
  class ShippingProtectionToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;
      this.variantId = parseInt(this.dataset.variantId, 10);
      this.productId = parseInt(this.dataset.productId, 10);
      this.checkbox.addEventListener('change', this.onToggle.bind(this));
    }

    async onToggle(event) {
      const wantsProtection = event.target.checked;
      this.setBusy(true);
      try {
        await ShippingProtectionToggle.mutateCart(this.variantId, wantsProtection);
      } catch (error) {
        console.error(error);
        event.target.checked = !wantsProtection;
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(isBusy) {
      this.checkbox.disabled = isBusy;
      this.classList.toggle('shipping-protection--loading', isBusy);
    }

    static async mutateCart(variantId, wantsProtection) {
      const cartUrlBase = (window.routes && window.routes.cart_url) || '/cart';
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';

      let mutateResponse;
      if (wantsProtection) {
        mutateResponse = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
      } else {
        // Target the exact line by its unique key rather than the raw variant
        // ID, which Shopify's /cart/change.js only resolves unambiguously when
        // it's the sole line for that variant.
        const cart = await fetch(`${cartUrlBase}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
          r.json()
        );
        const line = cart.items.find((item) => item.variant_id === variantId);
        if (!line) {
          await ShippingProtectionToggle.refreshCartSurfaces(cartUrlBase, variantId);
          return;
        }
        mutateResponse = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
      }

      if (!mutateResponse.ok) {
        throw new Error(`Shipping protection cart update failed: ${mutateResponse.status}`);
      }

      await ShippingProtectionToggle.refreshCartSurfaces(cartUrlBase, variantId);
    }

    static async refreshCartSurfaces(cartUrlBase, variantId) {
      const mainCartItems = document.getElementById('main-cart-items');
      const mainCartFooter = document.getElementById('main-cart-footer');
      const cartDrawerEl = document.getElementById('CartDrawer');
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      const fetchSection = (sectionId) =>
        fetch(`${cartUrlBase}?section_id=${sectionId}`).then((response) => response.text());

      const swapInner = (targetEl, html, selector) => {
        if (!targetEl) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector(selector);
        const destination = targetEl.querySelector(selector) || targetEl;
        if (source && destination) destination.innerHTML = source.innerHTML;
      };

      const tasks = [];

      if (mainCartItems && mainCartItems.dataset.id) {
        tasks.push(
          fetchSection(mainCartItems.dataset.id).then((html) => swapInner(mainCartItems, html, '.js-contents'))
        );
      }
      if (mainCartFooter && mainCartFooter.dataset.id) {
        tasks.push(
          fetchSection(mainCartFooter.dataset.id).then((html) => swapInner(mainCartFooter, html, '.js-contents'))
        );
      }
      if (cartDrawerEl) {
        tasks.push(fetchSection('cart-drawer').then((html) => swapInner(cartDrawerEl, html, '.drawer__inner')));
      }
      if (cartIconBubble) {
        tasks.push(
          fetchSection('cart-icon-bubble').then((html) => swapInner(cartIconBubble, html, '.shopify-section'))
        );
      }

      await Promise.all(tasks);

      try {
        const cart = await fetch(`${cartUrlBase}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
          r.json()
        );
        const isEmpty = cart.item_count === 0;
        if (mainCartFooter) mainCartFooter.classList.toggle('is-empty', isEmpty);
        const cartDrawerRoot = document.querySelector('cart-drawer');
        if (cartDrawerRoot) cartDrawerRoot.classList.toggle('is-empty', isEmpty);
        const cartDrawerItemsRoot = document.querySelector('cart-drawer-items');
        if (cartDrawerItemsRoot) cartDrawerItemsRoot.classList.toggle('is-empty', isEmpty);

        // Defensive backstop: the quantity stepper is hidden for this line in the
        // theme. Also guards against duplicate lines from something outside this
        // page's JS runtime (e.g. two tabs open at once each racing to add it).
        const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
        const spLines = cart.items.filter((line) => line.variant_id === variantId);

        if (spLines.length > 1) {
          // Keep the first line, zero out any duplicate lines by their unique key.
          await Promise.all(
            spLines.slice(1).map((line) =>
              fetch(changeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: 0 }),
              }).catch((error) => console.error(error))
            )
          );
        } else if (spLines.length === 1 && spLines[0].quantity > 1) {
          fetch(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: spLines[0].key, quantity: 1 }),
          }).catch((error) => console.error(error));
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  customElements.define('shipping-protection-toggle', ShippingProtectionToggle);
}
